import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType, ref } from 'vue';
import RichTextEditor from '@/components/editors/RichTextEditor.vue';
import { count } from 'sms-length';
import i18n from '@/plugins/i18n';
import Reservation from '@/model/Reservation';
import Message, { MessageType } from '@/grpc-api/model/message';
import { performDispatchAction } from '@/services/vue-utils';
import localized from '@/plugins/vue-localized-formatter/src/localized';
import store from '@/store/store';
import toast from '@/plugins/toast-plugin/toast';
import { ValidationObserver } from 'vee-validate';


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactMessageDialog',
  props: {
  reservation: { type: Object as PropType<Reservation>, required: true },
  feedbackId: { type: Number, required: false, default: undefined },
},
  emits: ['close'],
  setup(__props, { emit }) {

const props = __props;





const messageTypes = [MessageType.EMAIL, MessageType.SMS];
const messageType = ref(props.reservation.contact.email ? 0 : 1);

const directMessageFields = [
  { text: i18n.t('code.handlebar.restaurant_name'), value: 'restaurant_name' },
  { text: i18n.t('code.handlebar.full_name'), value: 'full_name' },
  { text: i18n.t('code.handlebar.party_size'), value: 'party_size' },
  { text: i18n.t('code.handlebar.start_date'), value: 'start_date' },
  { text: i18n.t('code.handlebar.start_time'), value: 'start_time' },
  { text: i18n.t('code.handlebar.end_time'), value: 'end_time' },
  { text: i18n.t('code.handlebar.reservation_note'), value: 'reservation_note' },
];

const body = ref('');
const emailSubject = ref('');
const emailBody = ref('');
const smsBody = ref('');

const isEmail = computed(() => messageTypes[messageType.value] === MessageType.EMAIL);
const isSMS = computed(() => messageTypes[messageType.value] === MessageType.SMS);

const smsMessagesCount = computed(() => {
  const c = count(smsBody.value || '');
  return i18n.t(
    'label.sms_messages_count',
    [c.length, c.characterPerMessage * (c.messages || 1), c.messages],
  );
});

function contentForField(field: string): string {
  switch (field) {
    case 'restaurant_name': return ` ${store.state.settings.account.accountName} `;
    case 'full_name': return props.reservation.contact.name ? ` ${props.reservation.contact.name} ` : '';
    case 'party_size': return ` ${String(props.reservation.partySize)} `;
    case 'start_date': return ` ${localized.dateText(props.reservation.dateBegin)} `;
    case 'start_time': return ` ${localized.hourMinText(props.reservation.dateBegin)} `;
    case 'end_time': return ` ${localized.hourMinText(props.reservation.dateEnd)} `;
    case 'reservation_note': return props.reservation.notes ? ` ${props.reservation.notes} ` : '';
    default: return '';
  }
}

function isContentForField(field: string): boolean {
  return contentForField(field) !== '';
}

function updateMessage(value: string) {
  if (isEmail.value) {
    emailBody.value = value;
  } else {
    smsBody.value = value;
  }
}

const observer = ref<InstanceType<typeof ValidationObserver>>();

async function sendMessage() {
  const message = new Message();
  message.reservationId = props.reservation.id;
  message.feedbackId = props.feedbackId;
  message.sendBcc = false;

  if (isEmail.value) {
    message.messageType = MessageType.EMAIL;
    message.subject = emailSubject.value;
    message.body = emailBody.value;
  } else {
    message.messageType = MessageType.SMS;
    message.subject = emailSubject.value;
    message.body = smsBody.value;
  }
  if (!await observer.value!.validate()) {
    toast.error(i18n.tc('error.validation_failed'));
    return;
  }

  const ok = await performDispatchAction('sendReservationMessage', { message });
  console.log('sendMessage: ', ok);
  if (!ok) return;
  toast.success(i18n.tc('message.message_successfuly_sent'));
  emit('close', true);
}


return { __sfc: true,emit, props, messageTypes, messageType, directMessageFields, body, emailSubject, emailBody, smsBody, isEmail, isSMS, smsMessagesCount, contentForField, isContentForField, updateMessage, observer, sendMessage, RichTextEditor, ValidationObserver }
}

})